import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ExportCsvImeiService } from './export-csv-imei.service';
import { MatDialog } from '@angular/material/dialog';
import { ScanQrcodeComponent } from 'app/modules/shared/containers/scan-qrcode/scan-qrcode.component';
import { take } from 'rxjs';
import { AddDeviceManualComponent } from '../device-configuration/device-management/add-device-manual/add-device-manual.component';
import { imeiRegex, QRCodeType } from 'app/modules/shared/models/common';
import { CommonService } from 'app/modules/shared/services/common';
import { SnackBarService } from 'app/core/snack-bar/snack-bar.service';
import { ExportNoticeService } from 'app/modules/shared/services/export-notice.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { OverlayModule } from '@angular/cdk/overlay';
import { AddMultipleImeisComponent } from '../device-configuration/device-management/add-multiple-imeis/add-multiple-imeis.component';

@Component({
    selector: 'export-csv-of-imei',
    imports: [MatButtonModule, MatIconModule, TranslocoModule, OverlayModule],
    templateUrl: './export-csv-of-imei.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './export-csv-of-imei.component.scss'
})
export class ExportCsvOfImeiComponent implements OnInit {
    // 354599263804323
    // 232345671234562
    imeis: string[] = [];

    isDeviceOverlayOpen = false;

    // private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _exportService: ExportCsvImeiService,
        private _matDialog: MatDialog,
        public _commonService: CommonService,
        private _snackBarService: SnackBarService,
        private _exportNotice: ExportNoticeService
    ) {}

    ngOnInit(): void {}

    exportCSV() {
        // Remind the user that they are responsible for the exported data (BSI O.Data_1, O.Data_2)
        this._exportNotice.confirm().subscribe((choice) => {
            if (choice) {
                this.downloadCsv();
            }
        });
    }

    private downloadCsv() {
        this._exportService
            .exportCSV(this.imeis)
            .pipe(take(1))
            .subscribe((blob) => {
                console.log(blob);
                const link = document.createElement('a');
                if (link.download !== undefined) {
                    const date = new Date().getTime();
                    // feature detection
                    const url = URL.createObjectURL(blob);
                    link.setAttribute('href', url);
                    link.setAttribute('download', date + '.csv');
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    // the file is held in memory by this address until it is released
                    setTimeout(() => URL.revokeObjectURL(url), 0);
                }
            });
    }

    openAddDeviceWithQRcodeDialog() {
        this.isDeviceOverlayOpen = false;
        // Open the dialog
        // const dialogRef = this._matDialog.open(AddDeviceWithQRcodeComponent, {
        //     width: '700px',
        // });
        const dialogRef = this._matDialog.open(ScanQrcodeComponent, {
            width: '700px',
        });

        dialogRef.afterClosed().subscribe((qrString) => {
            console.log('Compose dialog was closed!', qrString);
            if (qrString) {
                this.qrScannerValidation(qrString);
            }
        });
    }

    openAddDeviceManualDialog() {
        this.isDeviceOverlayOpen = false;

        // Open the dialog
        const dialogRef = this._matDialog.open(AddDeviceManualComponent, {
            width: '700px',
        });

        dialogRef.afterClosed().subscribe((imei) => {
            console.log('Compose dialog was closed!', imei);
            if (imei) {
                const index = this.imeis.findIndex((value) => value == imei);
                if (index == -1) {
                    this.imeis.push(imei);
                }
            }
        });
    }

    openAddMuitipleImeisDialog() {
        this.isDeviceOverlayOpen = false;

        // Open the dialog
        const dialogRef = this._matDialog.open(AddMultipleImeisComponent, {
            width: '700px',
        });

        dialogRef.afterClosed().subscribe((imeis: string[]) => {
            console.log('Compose dialog was closed!', imeis);
            if (imeis?.length) {
                imeis.forEach((imei) => {
                    this.qrScannerValidation(imei);
                });
            }
        });
    }

    qrScannerValidation(imei: string) {
        console.log('QR Result String:' + ' ' + imei);
        const qrType = this.identifyScannedString(imei);
        console.log(qrType);
        switch (qrType) {
            case QRCodeType.imeiQR:
                console.log('imei');
                const index = this.imeis.findIndex((value) => value == imei);
                if (index == -1) {
                    this.imeis.push(imei);
                }
                break;
            case QRCodeType.unknownQR:
                this._snackBarService.openSnackBar(
                    imei + ' ' + this._commonService.t('UNKNOWN-QR-CODE')
                );
                break;
        }
    }

    identifyScannedString(qrString: string): QRCodeType {
        if (imeiRegex.test(qrString)) {
            return QRCodeType.imeiQR;
        }
        return QRCodeType.unknownQR;
    }

    removeIMEI(imei: string) {
        const index = this.imeis.findIndex((value) => value == imei);
        if (index !== -1) {
            this.imeis.splice(index, 1);
        }
    }
}
